import { useContext } from "react";
import AuthContext from "../../../store/auth-context";
import s from "./style.module.sass";

const ModalIsWorking = () => {
    const ctx = useContext(AuthContext);
    const workingData = ctx?.userData?.workingHoursDay;
    const workingHours = ctx?.userData?.workingHours;

    if (!workingData) return window.location.reload();

    if (!workingData || !workingHours) return null;

    const nearest = workingData.nearest_time_work;

    const dayKey = nearest?.en?.toLowerCase();

    const dayHours = workingHours[dayKey] || [];
    const startHours = nearest.time_work_begin || '';

    let start = '';
    let end = '';

    if (Array.isArray(dayHours) && dayHours.length && startHours) {
        const found = dayHours.find(item => item.start === startHours);

        if (found) {
            start = found.start;
            end = found.end;
        }
    }

    const dateString = nearest?.date_work?.date;
    const date = dateString
        ? new Date(dateString.replace(" ", "T"))
        : null;

    const formattedDate = date
        ? date.toLocaleDateString("ru-RU", {
            day: "numeric",
            month: "long",
            year: "numeric",
        })
            .replace(/\s?г\.?/, "")
        : "";

    const workTimeText =
        formattedDate &&
        ((start ? `с ${start}` : '') +
            (start && end ? ' ' : '') +
            (end ? `до ${end}` : ''));

    const finalText =
        workTimeText
            ? `${formattedDate} ${workTimeText} по МСК`
            : '';

    return (
        <div className="container">
            <div className={s.modal__working}>
                <h2 className={s.name}>{ctx?.userData?.name},</h2>
                <p className={s.description}>Ваш рабочий день начнётся:</p>

                <div className={s.work__time}>
                    { (nearest.ru_short && finalText) && <span>{nearest.ru_short}</span>}
                    <p>
                        {
                            finalText ? `${finalText}` : "У вас нету доступа к ЛК. Обратитесь к администратору."
                        }
                    </p>
                </div>

                <div className={s.bottom__block}>
                    Сейчас у вас выходной, и личный кабинет закрыт для авторизации.<br />
                    Вы сами определяете своё рабочее расписание: только выбранные дни считаются рабочими.
                    В другие дни система автоматически ограничивает вход, чтобы сохранить порядок и не перегружать ваш график!
                </div>
            </div>
        </div>
    );
};

export default ModalIsWorking;